import { format } from 'path-browserify';
import React, { useState, useRef, useEffect } from 'react';

const HtmlPreviewSection = ({ data,setEditedData,editData }) => {
    const [selectedHtml, setSelectedHtml] = useState(null);

    const handleOpen = (html) => {
        setSelectedHtml(html);
    };

    const handleClose = () => {
        setSelectedHtml(null);
    };

    return (
        <>
            <div className="text-lg font-semibold mt-6">Previews</div>
            <div style={styles.previewContainer}>
                {data.map((item, index) => (
                    <PreviewBox
                        key={index}
                        html={item.html}
                        code={item.code}
                        onOpen={() => handleOpen(item.html)}
                        setEditedData={setEditedData}
                        editData={editData}
                    />
                ))}
            </div>

            {selectedHtml && (
    <div style={styles.modalOverlay} onClick={handleClose}>
        <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            {/* <div style={styles.modalHeader}>
                <button onClick={handleClose} style={styles.closeButton}>✖</button>
            </div> */}
            <div style={styles.modalBody}>
                <iframe
                    srcDoc={selectedHtml}
                    title="Modal Preview"
                    style={styles.modalIframe}
                />
            </div>
        </div>
    </div>
)}


        </>
    );
};

const PreviewBox = ({ html, code, onOpen,setEditedData,editData }) => {
    const iframeRef = useRef(null);

    const scaleContent = () => {
        const iframe = iframeRef.current;
        if (!iframe) return;
        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        const iframeBody = iframeDoc.body;

        iframeBody.style.margin = '0';
        iframeBody.style.padding = '0';
        iframeBody.style.boxSizing = 'border-box';

        const containerWidth = iframe.clientWidth;
        const containerHeight = iframe.clientHeight;

        const contentWidth = iframeBody.scrollWidth || 1;
        const contentHeight = iframeBody.scrollHeight || 1;

        const scaleX = containerWidth / contentWidth;
        const scaleY = containerHeight / contentHeight;
        const scale = Math.min(scaleX, scaleY, 1);

        iframeBody.style.transform = `scale(${scale})`;
        iframeBody.style.transformOrigin = 'top left';
        iframeBody.style.width = `${100 / scale}%`;
        iframeBody.style.height = `${100 / scale}%`;
    };

    useEffect(() => {
        const iframe = iframeRef.current;
        if (!iframe) return;

        iframe.onload = scaleContent;
        const timer = setTimeout(scaleContent, 500);

        window.addEventListener('resize', scaleContent);

        return () => {
            clearTimeout(timer);
            window.removeEventListener('resize', scaleContent);
        };
    }, [html]);

    return (
        <div style={styles.previewCard}>
            <div style={styles.previewBox} onClick={onOpen}>
                <iframe
                    ref={iframeRef}
                    srcDoc={html}
                    title={`Preview ${code}`}
                    style={styles.iframe}
                />
            </div>
            <div style={styles.cardFooter}>
                <span style={styles.previewLabel}>Preview {code}</span>
                <button
  style={{
    ...styles.selectButton,
    backgroundColor: editData.format === code ? '#007bff' : '#d2d5da',
    color: editData.format === code ? 'white' : '#fff',
  }}
  onClick={(e) => {
    e.stopPropagation();
    setEditedData(prev => ({
      ...prev,
      format: code
    }));
  }}
>
  {editData.format === code ? "Selected" : "Select"}
</button>

            </div>
        </div>
    );
};

const styles = {
    previewContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '20px',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        padding: '20px',
    },
    previewCard: {
        width: '300px',
        border: '1px solid #d2d5da',
        borderRadius: '12px',
        overflow: 'hidden',
        backgroundColor: '#ffffff',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        transition: 'transform 0.2s',
        
    },
    previewBox: {
        width: '100%',
        overflow: 'hidden',
        backgroundColor: '#fff',
        position: 'relative',
        cursor: 'pointer',
    },
    iframe: {
        width: '100%',
        height: '100%',
        border: 'none',
        pointerEvents: 'none',
        backgroundColor: 'transparent',
    },
    cardFooter: {
        width: '100%',
        padding: '10px',
        borderTop: '1px solid #d2d5da',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    previewLabel: {
        fontWeight: 'bold',
        fontSize: '14px',
        color: '#333',
    },
    selectButton: {
        backgroundColor: '#d2d5da',
        border: 'none',
        borderRadius: '6px',
        padding: '6px 12px',
        cursor: 'pointer',
        fontWeight: 'bold',
    },
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
        backdropFilter: 'blur(4px)',
    },
    modalContent: {
        width: '80vw',
        height: '80vh',
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        position: 'relative',
        boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
        border: '1px solid #d2d5da',
    },    
    closeButton: {
        position: 'absolute',
        top: '12px',
        right: '20px',
        border: 'none',
        background: 'transparent',
        fontSize: '28px',
        cursor: 'pointer',
        color: '#333',
    },
    modalHtmlWrapper: {
        paddingTop: '24px',
    },
    modalIframe: {
        width: '100%',
        height: '100%',
        border: 'none',
        backgroundColor: 'transparent',
    },
    modalHeader: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '8px',
        backgroundColor: '#fff',
        borderBottom: '1px solid #d2d5da',
    },
    
    modalBody: {
        flex: 1,
        overflow: 'auto',
    },
    
    modalIframe: {
        width: '100%',
        height: '100%',
        border: 'none',
        backgroundColor: 'transparent',
    },
    
    
};

export default HtmlPreviewSection;
